import { Grid } from "@material-ui/core"
import { WarningIcon } from "App/Assets"
import { MasterButton, Modal } from "App/Component/ui"
import { isSSO } from "App/constants"
import { removeCookie } from "App/utils/cookies"
import Cookies from "js-cookie"
import React from "react"
import { useHistory } from "react-router-dom"

const ModalLogout = ({ setShowModal }) => {
  let history = useHistory()
  const confirmLogout = () => {
    localStorage.clear()
    removeCookie()
    Cookies.set("Secure-out", "OK")
    if (isSSO) {
      window.location.replace(process.env.REACT_APP_SSO_LOGIN_PAGE)
    } else {
      history.push("/")
    }
  }

  return (
    <Modal title="Logout" show={setShowModal} width="25%" backgroundTitle="red">
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          gap: "20px",
          marginTop: "1rem",
          marginBottom: "1rem",
        }}
      >
        <WarningIcon width="150px" height="150px" />
        <p className="fs-12">Apakah anda yakin ingin logout?</p>
      </div>

      <Grid
        direction="row"
        container
        justifyContent="flex-end"
        alignItems="center"
      >
        <MasterButton
          outline={true}
          className={"mr-1 mt-1"}
          type={"button"}
          color="secondary"
          name="Batal"
          onClick={() => setShowModal(false)}
          size="md"
        />
        <MasterButton
          className={"mt-1"}
          type={"button"}
          color="danger"
          name="Ya, Logout"
          onClick={confirmLogout}
          size="md"
        />
      </Grid>
    </Modal>
  )
}
export default ModalLogout
